/** Importe de montaje BASE (sin IVA) por línea + sugerencia histórica explicable (nunca autoaplicada). */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ImporteMontaje({ linea, idx, clienteId, onChange, onAplicarTodos }) {
  const [sug, setSug] = useState(null);
  const tipos = linea.tipos || [];
  const tipoTrabajo = tipos.includes("produccion") && tipos.includes("montaje") ? "produccion_montaje" : tipos.includes("montaje") ? "solo_montaje" : tipos.includes("produccion") ? "solo_produccion" : "otro";
  useEffect(() => {
    setSug(null);
    if (!clienteId || !linea.espacio_id || !tipos.includes("montaje")) return;
    api.get("/parser-learning/sugerir-importe", { params: { cliente_id: clienteId, espacio_id: linea.espacio_id, tipo_trabajo: tipoTrabajo } })
      .then((r) => { setSug(r.data); if (r.data?.sugerido != null) onChange({ precio_montaje_sugerido: r.data.sugerido }); }).catch(() => {});
  }, [clienteId, linea.espacio_id, tipoTrabajo]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!tipos.includes("montaje")) return null;
  return (
    <div className="mt-2 pl-1 flex flex-wrap items-end gap-2" data-testid={`importe-montaje-${idx}`}>
      <div>
        <Label className="text-[10px] text-zinc-500">Importe montaje (base, sin IVA) €</Label>
        <Input type="number" min="0" step="0.01" value={linea.precio_montaje ?? ""} placeholder={sug?.sugerido != null ? `${sug.sugerido}` : "manual"}
          onChange={(e) => onChange({ precio_montaje: e.target.value === "" ? null : Number(e.target.value), precio_montaje_origen: "manual" })}
          className="bg-zinc-950 border-zinc-800 h-8 text-[11px] px-1 w-32" data-testid={`importe-montaje-input-${idx}`} />
      </div>
      {sug?.sugerido != null ? (
        <div className="text-[10px] text-amber-200/90 flex items-center gap-2" data-testid={`importe-sugerencia-${idx}`} title={sug.motivo}>
          <span>Sugerido: <b>{sug.sugerido} €</b> · basado en {sug.n} trabajo(s) previos{sug.min !== sug.max ? ` (rango ${sug.min}–${sug.max} €)` : ""}</span>
          <button type="button" className="underline text-emerald-300" data-testid={`importe-usar-${idx}`}
            onClick={() => onChange({ precio_montaje: sug.sugerido, precio_montaje_origen: "sugerido_confirmado" })}>Usar sugerencia</button>
        </div>
      ) : (
        <span className="text-[10px] text-zinc-500">{sug ? sug.motivo : "sin histórico: introduce el importe"}</span>
      )}
      {linea.precio_montaje != null && onAplicarTodos && (
        <button type="button" className="text-[10px] underline text-zinc-300" data-testid={`importe-aplicar-todos-${idx}`} onClick={() => onAplicarTodos(linea.precio_montaje)}>Aplicar a todas las líneas</button>
      )}
    </div>
  );
}
